import { Component, Injector, Input, ViewChild } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'md-document-comfirmation-received',
  template: require('./document-confirmation-received.component.html'),
  styles: [require('./document-confirmation-received.component.scss')]
})
export class DocumentConfirmationReceivedComponent extends BaseRoute {
  @Input() form;
  @ViewChild('focusItem') focusItem;

  // eslint-disable-next-line no-useless-constructor
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.appActions.setData('stepUserIsOn', 0);
    if (this.focusItem) {
      this.focusItem.nativeElement.focus();
    }
  }
}
